import React,{useEffect} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes , Route,Outlet} from "react-router-dom";
import HomeRoute from './components/Home/HomeRoute';
import CategoryDetail from './components/Browse/CategoryDetail';
import SearchResult from './components/Search/SearchResult';
import VirtualTour from './components/Search/VirtualTour';
import ResultDashboard from './components/Search/Dashboard';
import PropertyScreen from './components/Search/propertyDetail';
import CanvasTerrain from './canvas';
function App() {
  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
}, [ ])
  return (
  // <Router basename={"/easyrece"}>
   <Router basename={"/"}>
  {/* // <Router basename={"/public"}>
   <Router>  */}

      <Routes>
            <Route path='/' element={<HomeRoute />} />
            <Route path='/property-detail/:url' element={<CategoryDetail />} />
            <Route path='/searchResult' element={<SearchResult />} />
            <Route path='/virtual-tour' element={<VirtualTour />} />
            <Route path='/dashboard' element={<ResultDashboard />} />
            <Route path='/property/:url' element={<PropertyScreen />} />
            <Route path='/canvas' element={<CanvasTerrain />} />
      </Routes>
      </Router>
      
   
  );
}

export default App;